import React from 'react';
import ForgotPassword from 'components/Login/ForgotPassword';

export default (props) => (
  <ForgotPassword {...props} />
);
